import mixpanel from 'mixpanel-browser'
import { MIXPANEL_PROJECT_ID } from '../../config'

let isInitialized = false

/**
 * Initialize Mixpanel once at app startup.
 * Safe to call multiple times - will only initialize once.
 */
export function initMixpanel(): boolean {
  if (isInitialized) {
    return true
  }

  if (!MIXPANEL_PROJECT_ID) {
    console.warn('Mixpanel: No project ID configured, tracking disabled')
    return false
  }

  try {
    mixpanel.init(MIXPANEL_PROJECT_ID, { ignore_dnt: true })
    isInitialized = true
    return true
  } catch (error) {
    console.error('Mixpanel: Failed to initialize', error)
    return false
  }
}

/**
 * Check if Mixpanel has been initialized successfully.
 */
export function isMixpanelInitialized(): boolean {
  return isInitialized
}
